<template>
  <div>
    <div>
      <searchCpn @handleQuery="handleQuery"/>
    </div>
    <div>
      <div class="boards_header">
        <div class="row">
          <div class="row1">
            {{showText.title}}
          </div>
          <div class="row2">
            {{showText.text}}
          </div>
          <div class="row3">
          </div>
        </div>
        <div class="row">
          <div class="row1">
            {{$t('fuelEfficientDriving.平均分')}}
          </div>
          <div class="row2" >
            {{boardsScore}}
          </div>
          <div class="row3">
            {{$t('fuelEfficientDriving.环比')}} <span :style="{'color':boardsRateColor}">{{boardsRate}}</span>
          </div>
        </div>
        <div class="row">
          <div class="row1">
            {{$t('fuelEfficientDriving.评分等级')}}
          </div>
          <div class="row2" :style="{'color':boardsColor}">
            {{boardsLevel}}
          </div>
          <div class="row3">
          </div>
        </div>
      </div>
      <div style="display:flex;">
        <div class="boardsContain">
          <div class="contaiTitle">{{$t('fuelEfficientDriving.车辆评分等级分布')}}</div>
          <div style="margin-top:30px;display: flex;justify-content: space-evenly;">
            <div style="display: flex;"><div class="fangkuai"></div><span>{{$t('fuelEfficientDriving.优秀')}}({{piedata[0].value}})</span></div>
            <div style="display: flex;"><div class="fangkuai" style="background:#0094E6"></div><span>{{$t('fuelEfficientDriving.良好')}}({{piedata[1].value}})</span></div>
            <div style="display: flex;"><div class="fangkuai" style="background:#DEAD00"></div><span>{{$t('fuelEfficientDriving.中等')}}({{piedata[2].value}})</span></div>
            <div style="display: flex;"><div class="fangkuai" style="background:#F57E00"></div><span>{{$t('fuelEfficientDriving.一般')}}({{piedata[3].value}})</span></div>
            <div style="display: flex;"><div class="fangkuai" style="background:#F22015"></div><span>{{$t('fuelEfficientDriving.差')}}({{piedata[4].value}})</span></div>
          </div>
          <div>
            <div id="chart_level" style="height:360px"></div>
          </div>
        </div>
        <div style="width:20px;"></div>
        <div class="boardsContain">
          <div style="display:flex;justify-content: space-between;cursor: pointer;" @click="goto()">
            <div class="contaiTitle">{{$t('fuelEfficientDriving.行为评分分布')}}</div>
            <div><i class="el-icon-arrow-right" style="font-size:16px;color:#999999;font-weight: 600;"></i></div>
          </div>
          <div style="display:flex;justify-content: center;margin-top:16px">
            <div class="switchBtn">
              <div class="scoreBtn" 
                :style="{'color':scoreOrCountBtn==1?'#2A7AFF':'#666666','background':scoreOrCountBtn==1?'rgba(42,122,255,0.2)':''}" @click="scoreOrCountClick(1)">
                {{$t('fuelEfficientDriving.评分')}}</div>
              <div class="countBtn" 
                :style="{'color':scoreOrCountBtn==2?'#2A7AFF':'#666666','background':scoreOrCountBtn==2?'rgba(42,122,255,0.2)':''}" @click="scoreOrCountClick(2)">
                {{$t('fuelEfficientDriving.次数')}}</div>
            </div>
          </div>
          <div>
            <div id="chart_radarScore" style="height:340px;" v-show="scoreOrCountBtn==1"></div>
            <div id="chart_radarCount" style="height:340px;" v-show="scoreOrCountBtn==2"></div>
          </div>
          <div style="display:flex;justify-content: space-evenly;">
            <div style="display:flex">
              <div style="width: 9px;height: 9px;background: #3CAA16;border-radius: 50%;margin-right:8px;"></div><span style="color:#333333">{{chart_radarName[0]}}</span>
            </div>
            <div style="display:flex">
              <div style="width: 9px;height: 9px;background: #0C96E3;border-radius: 50%;margin-right:8px;"></div><span style="color:#333333">{{chart_radarName[1]}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import searchCpn from "@/views/driver/fuel_efficient_driving/components/searchCpn.vue"
// import * as echarts from 'echarts'
import { mapState } from 'vuex'
export default {
  components:{searchCpn},
  props:{
    cpnName: {
      type: String,
      default: "",
    },
  },
  data(){
    return{
      loading:false,
      scoreOrCountBtn:1,
      searchType:"日",
      dateDay:new Date(new Date().getTime() - 24 * 60 * 60 * 1000),
      dateWeek: new Date(),
      dateMonth: new Date(),
      datePickerOptions: {
        disabledDate(date) {
          return date > new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
        }
      },
      beginDate:undefined,
      endDate:undefined,
      chart_level:undefined,
      piedata:[{ name: this.$t('fuelEfficientDriving.优秀'), value: 0,},
        { name: this.$t('fuelEfficientDriving.良好'), value: 0,},
        { name: this.$t('fuelEfficientDriving.中等'), value: 0,},
        { name: this.$t('fuelEfficientDriving.一般'), value: 0,},
        { name: this.$t('fuelEfficientDriving.差'), value: 0,}],
      chart_radarCount:undefined,
      chart_radarScore:undefined,
      boardsScore:"",
      boardsLevel:"",
      boardsRate:"",
      boardsRateColor:"",
      boardsColor:"",
      radarDataCountRatio:"",
      radarDataCount:"",
      chart_levelDom:undefined,
      chartColor:['#36AC00', '#0094E6', '#DEAD00', '#F57E00', '#F22015', ],
      badDrivingScoreData:undefined,
      badDrivingCountData:undefined,
      chart_radarName:["",""],
      vehicles:"",
      vehicleName:"",
      showText:{
        title:this.$t('fuelEfficientDriving.参评企业'),
        text:"",
      }
    }
  },
  computed: {
    size() {
      return this.$store.getters.size
    },
    ...mapState({
      selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
  },
  mounted(){
    this.searchType = this.$t('time.day');
    this.chart_radarName = [this.$t('fuelEfficientDriving.得分'),this.getScoreType()];
    this.$nextTick(()=>{
      this.showText.text = this.cpnName;
      this.initChart();
      this.pieChart();
      this.radarChartScore();
      this.radarChartCount();
      this.setResize();
    });
    window.addEventListener('resize',this.setResize);
  },
  activated(){
    this.$nextTick(()=>{
      this.setResize();
    });
    window.addEventListener('resize',this.setResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.setResize)
  },
  deactivated(){
    window.removeEventListener('resize', this.setResize)
  },
  methods:{
    getSelectedVehicles() {
      this.vehicles = "";
      this.vehicleName = "";
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          this.vehicles =
            this.vehicles + this.selectedVehicles[k].nodeValue + ",";
          this.vehicleName =
            this.vehicleName + this.selectedVehicles[k].vehicleName + ",";
        }
      }
      return this.vehicles.substring(0, this.vehicles.length - 1);
    },
    setResize(){
      this.chart_level.resize();
      this.chart_radarCount.resize();
      this.chart_radarScore.resize();
    },
    goto(){
      let params = {
        startDate: this.beginDate,
        endDate: this.endDate,
        showText:this.showText,
        cpnName:this.cpnName,
        vehicles:this.vehicles,
        initSearchType: this.initSearchType
      }
      this.$router.push({
        path: "/fuel_efficient_driving/abnormal_detail",
        query: {
          dateData: JSON.stringify(params) // 将对象转为JSON字符串传递
        }
      });
    },
    scoreOrCountClick(val){
      this.scoreOrCountBtn = val;
      this.$nextTick(() => { // 等待 DOM 更新完成（v-show 生效）
        if(this.scoreOrCountBtn==1){
          this.chart_radarScore.resize();
          this.chart_radarName = [this.$t('fuelEfficientDriving.得分'),this.getScoreType()];
        }else if(this.scoreOrCountBtn==2){
          this.chart_radarCount.resize();
          this.chart_radarName = [this.$t('fuelEfficientDriving.次数'),this.getCountType()];
        }
      })
    },
    handleQuery(val){
      // console.log(val)
      this.initSearchType = val.initSearchType;
      this.beginDate = val.beginDate;
      this.endDate = val.endDate;
      if(this.scoreOrCountBtn==1){
        this.chart_radarName = [this.$t('fuelEfficientDriving.得分'),this.getScoreType()];
      }else if(this.scoreOrCountBtn==2){
        this.chart_radarName = [this.$t('fuelEfficientDriving.次数'),this.getCountType()];
      }
      this.vehicles = this.getSelectedVehicles();
      if(this.vehicles.indexOf(',')>-1){
        this.$message({
          message: this.$t('vehicletrack.selectmorevehicle'),
          type: "warning", 
        })
        return false;
      }
      this.getData();
    },
    getData(){
      this.$api.queryFuelEffiGradeScoreDashboard({
        OperatorID: this.$store.getters.operator.OperatorId + "",
        BeginDate: this.beginDate, 
        EndDate: this.endDate,
        VehicleID: this.vehicles,//vehicleID
      })
      .then((res)=>{
        if(this.vehicles == ""){
          this.showText.title = this.$t('fuelEfficientDriving.参评企业');
          this.showText.text = this.cpnName;
        }else{
          this.vehicleName = this.vehicleName.substring(0,this.vehicleName.length-1);
          this.showText.title = this.$t('fuelEfficientDriving.参评车辆');
          this.showText.text = this.vehicleName;
        }

        // 环形图数据
        let RankNameCountData = res.data.RankNameCountData;
        let itemRingData = [{ name: this.$t('fuelEfficientDriving.优秀'), value: 0,},
        { name: this.$t('fuelEfficientDriving.良好'), value: 0,},
        { name: this.$t('fuelEfficientDriving.中等'), value: 0,},
        { name: this.$t('fuelEfficientDriving.一般'), value: 0,},
        { name: this.$t('fuelEfficientDriving.差'), value: 0,}]
        if(RankNameCountData.length == 0){
          this.piedata = itemRingData;
        }else{
          RankNameCountData.forEach((element,index)=>{
            let rankName = element.RankName;
            switch(rankName){
              case "优秀":
                itemRingData[0].value = element.Count;
                break;
              case "良好":
                itemRingData[1].value = element.Count;
                break;
              case "中等":
                itemRingData[2].value = element.Count;
                break;
              case "一般":
                itemRingData[3].value = element.Count;
                break;
              case "差":
                itemRingData[4].value = element.Count;
                break;
            }
          });
          this.piedata = itemRingData;
        }
        this.pieChart(this.piedata);
        let isHave = res.data.RankNameScoreData.Score ? true : false;
        this.boardsScore = isHave ? res.data.RankNameScoreData.Score.toString() : "- -";
        this.boardsLevel = isHave ? res.data.RankNameScoreData.RankName : "- -";
        this.boardsRate = isHave ? this.getAboardRate(res.data.RankNameScoreData.PoPScore).text : "- -";
        this.boardsRateColor = isHave ? this.getAboardRate(res.data.RankNameScoreData.PoPScore).color : "#333";
        this.boardsColor = isHave ? this.getTextColor(res.data.RankNameScoreData.Score) : "#333";

        // 雷达图数据
        //评分
        let BadDrivingScoreData = res.data.BadDrivingScoreData;
        let itemRadarScoreData = [[0,0,0,0,0,0],[0,0,0,0,0,0]];
        if(BadDrivingScoreData.length>0){
          BadDrivingScoreData.forEach((element,index)=>{
            let GItemName = element.GItemName;
            switch(GItemName){
              case "长时间怠速":
                itemRadarScoreData[0][0] = element.Score;
                itemRadarScoreData[1][0] = element.PScore;

                break;
              case "急加速":
                itemRadarScoreData[0][1] = element.Score;
                itemRadarScoreData[1][1] = element.PScore;
                break;
              case "空挡滑行":
                itemRadarScoreData[0][2] = element.Score;
                itemRadarScoreData[1][2] = element.PScore;
                break;
              case "空调温度过低":
                itemRadarScoreData[0][3] = element.Score;
                itemRadarScoreData[1][3] = element.PScore;
                break;
              case "超速行驶":
                itemRadarScoreData[0][4] = element.Score;
                itemRadarScoreData[1][4] = element.PScore;
                break;
              case "急减速":
                itemRadarScoreData[0][5] = element.Score;
                itemRadarScoreData[1][5] = element.PScore;
                break;
              
            }
          })
        }
        this.badDrivingScoreData = itemRadarScoreData;
        this.radarChartScore(this.badDrivingScoreData);
        //次数
        let BadDrivingCountData = res.data.BadDrivingCountData;
        let itemRadarCountData = [[0,0,0,0,0,0],[0,0,0,0,0,0]];
        let itemRadarValueOther = ["0%","0%","0%","0%","0%","0%"];
        if(BadDrivingCountData.length>0){
          BadDrivingCountData.forEach((element,index)=>{
            let valueOther = element.PoPCount > 0 ? "+"+element.PoPCount+'%⬆' : element.PoPCount == 0 ? '0%' : element.PoPCount+'%⬇'
            let GItemName = element.GItemName;
            switch(GItemName){
              case "长时间怠速":
                itemRadarCountData[0][0] = element.Count;
                itemRadarCountData[1][0] = element.PCount;
                itemRadarValueOther[0] = valueOther;
                break;
              case "急加速":
                itemRadarCountData[0][1] = element.Count;
                itemRadarCountData[1][1] = element.PCount;
                itemRadarValueOther[1] = valueOther;
                break;
              case "空挡滑行":
                itemRadarCountData[0][2] = element.Count;
                itemRadarCountData[1][2] = element.PCount;
                itemRadarValueOther[2] = valueOther;
                break;
              case "空调温度过低":
                itemRadarCountData[0][3] = element.Count;
                itemRadarCountData[1][3] = element.PCount;
                itemRadarValueOther[3] = valueOther;
                break;
              case "超速行驶":
                itemRadarCountData[0][4] = element.Count;
                itemRadarCountData[1][4] = element.PCount;
                itemRadarValueOther[4] = valueOther;
                break;
              case "急减速":
                itemRadarCountData[0][5] = element.Count;
                itemRadarCountData[1][5] = element.PCount;
                itemRadarValueOther[5] = valueOther;
                break;
            }
          })
        }
        this.badDrivingCountData = itemRadarCountData;
        let max1 = Math.max(...itemRadarCountData[0]);
        let max2 = Math.max(...itemRadarCountData[1]);
        let max = Math.max(max1,max2);
        // console.log(max);
        this.radarChartCount(this.badDrivingCountData,max)
      })
      .catch(()=>{

      })
    },
    getAboardRate(value){
      if(value > 0){
        return {text:'+'+value+'%',color:"#3CAA16"}
      }else{
        return {text:value+'%',color:"#EF2424"}
      }
    },
    getTextColor(score){
      if(score<=100 && score >= 90){
        return "#3CAA16";
      }else if(score < 90 && score >= 80){
        return "#0C96E3";
      }else if(score < 80 && score >= 70){
        return "#F37E08";
      }else if(score < 70 && score >= 60){
        return "#DDAC00";
      }else if(score < 60 && score >0){
        return "#EF2424";
      }else{
        return "#F1F1F1";
      }
    },
    initChart(){
      this.chart_radarCount = echarts.init(document.getElementById('chart_radarCount'));
      this.chart_radarScore = echarts.init(document.getElementById('chart_radarScore'));
      this.chart_level = echarts.init(document.getElementById('chart_level'));
      this.chart_levelDom = document.getElementById('chart_level');
    },
    radarChartCount(data,max){
      let toolTipData = ['长时间怠速','急加速','空挡滑行','空调温度过低','超速行驶','急减速']
      max = max ? max : 100;
      var option = {
        // color: ['#67F9D8', '#FFE434'],
        color: ['#3CAA16', '#0C96E3'],
        tooltip: {
          trigger: 'item',
          formatter: function(params) {
            var relVal= '';
            relVal+='<span style="font-size: 13px;">'+params.name+'</span>'
            for(let i=0;i< params.data.value.length; i++){
              relVal += `
                <div style="display: flex; align-items: center; margin: 2px 0;">
                  <div style="width: 4px; height: 4px; background: ${params.color}; border-radius: 50%; margin-right: 8px;"></div>
                  <span style="font-size: 13px;">${toolTipData[i]}：<span style="font-size: 13px;font-weight: 600;">${params.data.value[i]}</span> 次</span>
                </div>
              `;
            }
            return relVal;
          }
        },
        radar: {
          // shape: 'circle',
          indicator: [
            { name: this.$t('fuelEfficientDriving.长时间怠速'), max: max },
            { name: this.$t('fuelEfficientDriving.急加速'), max: max },
            { name: this.$t('fuelEfficientDriving.空挡滑行'), max: max },
            { name: this.$t('fuelEfficientDriving.空调温度过低'), max: max },
            { name: this.$t('fuelEfficientDriving.超速行驶'), max: max },
            { name: this.$t('fuelEfficientDriving.急减速'), max: max }
          ]
        },
        series: [
          {
            type: 'radar',
            data: [
              {
                value:  data ? data[0]:[],// [20, 30, 2, 35, 50, 18],
                name: this.$t('fuelEfficientDriving.次数'),
                areaStyle: {
                  color: 'rgba(60, 170, 22, 0.6)'
                }
              },
              {
                value:  data ? data[1]:[],// [50, 40, 28, 60, 40, 21],
                name: this.getCountType(),
                areaStyle: {
                  color: 'rgba(12, 150, 227, 0.6)'
                }
              }
            ]
          }
        ]
      };
      this.chart_radarCount.setOption(option);
    },
    radarChartScore(data){
      let toolTipData = ['长时间怠速','急加速','空挡滑行','空调温度过低','超速行驶','急减速']
      var option = {
        // color: ['#67F9D8', '#FFE434'],
        color: ['#3CAA16', '#0C96E3'],
        tooltip: {
          trigger: 'item',
          formatter: function(params) {
            var relVal= '';
            relVal+='<span style="font-size: 13px;">'+params.name+'</span>'
            for(let i=0;i< params.data.value.length; i++){
              relVal += `
                <div style="display: flex; align-items: center; margin: 2px 0;">
                  <div style="width: 4px; height: 4px; background: ${params.color}; border-radius: 50%; margin-right: 8px;"></div>
                  <span style="font-size: 13px;">${toolTipData[i]}：<span style="font-size: 13px;font-weight: 600;">${params.data.value[i]}</span> 分</span>
                </div>
              `;
            }
            return relVal;
          }
        },
        radar: {
          indicator: [
            { name: this.$t('fuelEfficientDriving.长时间怠速'), max: 100 },
            { name: this.$t('fuelEfficientDriving.急加速'), max: 100 },
            { name: this.$t('fuelEfficientDriving.空挡滑行'), max: 100 },
            { name: this.$t('fuelEfficientDriving.空调温度过低'), max: 100 },
            { name: this.$t('fuelEfficientDriving.超速行驶'), max: 100 },
            { name: this.$t('fuelEfficientDriving.急减速'), max: 100 }
          ]
        },
        series: [
          {
            type: 'radar',
            data: [
              {
                value: data ? data[0]:[],// [42, 30, 2, 50, 5, 10],
                name: this.$t('fuelEfficientDriving.得分'),
                areaStyle: {
                  color: 'rgba(60, 170, 22, 0.6)'
                }
              },
              {
                value: data ? data[1]:[],// [30, 10, 20, 20, 40, 20],
                name: this.getScoreType(),// this.$t('fuelEfficientDriving.上月得分'),
                areaStyle: {
                  color: 'rgba(12, 150, 227, 0.6)'
                }
              }
            ]
          }
        ]
      };
      this.chart_radarScore.setOption(option,true);
    },
    getScoreType(){
      // console.log(this.initSearchType);
      switch(this.initSearchType){
        case this.$t("time.day"):
          return this.$t('fuelEfficientDriving.昨日得分');
          break;
        case this.$t("time.week"):
          return this.$t('fuelEfficientDriving.上周得分');
          break;
        case this.$t("time.month"):
          return this.$t('fuelEfficientDriving.上月得分');
        default: return this.$t('fuelEfficientDriving.昨日得分');
      }
    },
    getCountType(){
      switch(this.initSearchType){
        case this.$t("time.day"):
          return this.$t('fuelEfficientDriving.昨日次数');
          break;
        case this.$t("time.week"):
          return this.$t('fuelEfficientDriving.上周次数');
          break;
        case this.$t("time.month"):
          return this.$t('fuelEfficientDriving.上月次数')
        default: return this.$t('fuelEfficientDriving.昨日次数');
      }
    },
    pieChart(data){
      const _this = this;
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: "{b} : {c} ({d}%)"
        },
        series:{
          type: 'pie',
          radius: ["40%", "65%"],
          height: '100%',
          width: "100%",
          itemStyle: {
            color: function (params) { // 参数名改为 params 更规范
              return _this.chartColor[params.dataIndex % _this.chartColor.length];
            },
            borderColor: '#fff',//每个颜色之间的间隙颜色
            borderWidth: 1.5,//间隙宽度
          },
          label: {
            show: false,
            // position: 'center'
          },
          labelLine: {
            show: false
          },
          data: data ? data : []
        }
        
      }
      this.chart_level.setOption(option, true)

    },
  }
}
</script>
<style scoped lang="scss">
.boards_header{
  height: 160px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #D9E4F8;
  display: flex;
  align-items: center;
  flex-direction: row;
}
.row{
  flex:1;text-align: center;
}
.row1{
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  margin-top:8px;
}
.row2{
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 24px;
  color: #333333;
  margin-top:8px;
}
.row3{
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #333333;
  margin-top:8px;
}
.boardsContain{
  flex: 1;
  margin-top: 20px;
  height: 450px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #D9E4F8;
  padding: 24px;
}
.contaiTitle{
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #0F1A3A;
}
.fangkuai{
  width: 12px;
  height: 12px;
  background: #36AC00;
  border-radius: 2px;
  margin-right: 8px;
}
.switchBtn{
  width: 50%;
  height: 32px;
  border-radius: 18px;
  border: 1px solid #A2B1CB;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.countBtn{
  flex: 1;
  height: 28px;
  border-radius: 18px;
  font-weight: 600;
  font-size: 12px;
  display: grid;
  place-items: center;
}
.scoreBtn{
  flex: 1;
  height: 28px;
  border-radius: 18px;
  font-weight: 600;
  font-size: 12px;
  display: grid;
  place-items: center;
  
}
</style>